import { Avatar, ListItemAvatar, ListItemText, Typography, Box, Theme } from '@mui/material';
import { CSSProperties, FC, ReactNode } from 'react';

import { User, UserMin } from '@apiContract';

const sx = {
  sxItemAvatar: {
    position: 'relative',
  },
  sxAvatar: (theme: Theme, opacity: boolean) => ({
    bgcolor: theme.palette.grey[700],
    textTransform: 'uppercase',
    color: theme.palette.grey[500],
    opacity: opacity ? 0.3 : 1,
  }),
  sxCutText: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' },
};

type Props = {
  user: User | UserMin;
  AvatarChild?: ReactNode;
  opacity?: boolean;
  useTitle?: boolean;
  style?: CSSProperties;
};

const UserListDisplay: FC<Props> = ({ user, AvatarChild, opacity = false, useTitle = false, style }) => (
  <Box display="flex" sx={style}>
    <ListItemAvatar sx={sx.sxItemAvatar}>
      <Avatar
        sx={(theme: Theme) => sx.sxAvatar(theme, opacity)}
        alt={`${user?.firstName} ${user?.lastName}`}
        src={user?.profileImageUrl}
      >
        {user?.firstName?.charAt(0)}
        {user?.lastName?.charAt(0)}
      </Avatar>
      {!!AvatarChild && AvatarChild}
    </ListItemAvatar>
    <ListItemText
      primary={
        <Typography title={useTitle ? user.displayName : undefined} sx={sx.sxCutText} variant="subtitle2">
          {user.displayName}
        </Typography>
      }
      secondary={
        <Typography
          title={useTitle ? user?.userName : undefined}
          sx={sx.sxCutText}
          color="text.secondary"
          variant="body2"
        >
          {user?.userName}
        </Typography>
      }
    />
  </Box>
);

export default UserListDisplay;
